<template>
  <div>
    <ts-dialog title="Change the asset's platform" :visible.sync="visible" width="450px" center :show-close="false">
      <div class="form-row">
        <ts-form-item label="Platform(s)" :validation="$v.form.platforms" class="form-item">
          <MultiSelectionDropdown
            placeholder="Select platform(s)"
            size="large"
            :width="320"
            :options="platforms"
            v-model.lazy="$v.form.platforms.$model"
          ></MultiSelectionDropdown>
        </ts-form-item>
      </div>
      <span slot="footer">
        <ts-button @click="handleSaveClick">Apply</ts-button>
      </span>
    </ts-dialog>
    <!-- <ts-button size="small" :type="platformButtonClass" filled :loading="loading" @click="handleEditClick">
      Select your platform
    </ts-button> -->
  </div>
</template>

<style lang="scss" scoped>
.form-row {
  display: flex;
  padding: 12px 18px;
  align-items: flex-end;

  .checkbox {
    margin-bottom: 30px;
  }

  .actions {
    margin-bottom: 14px;
  }

  .form-item {
    margin: 0 10px;
  }
}
</style>

<script>
import { mapState, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';

import MultiSelectionDropdown from '@/components/inputs/MultiSelectionDropdown.vue';

export default {
  components: {
    MultiSelectionDropdown
  },
  props: {
    assets: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      callback: null,
      form: {
        platforms: []
      }
    };
  },
  mounted() {
    this.fetchProjectOptions();
    window.EventBus.$on('Delivery.PlatformSelection', callback => {
      this.callback = callback;
      this.handleEditClick();
    });
  },
  computed: {
    ...mapState('workflow', {
      platforms: state => state.myProjects.options.platforms
    }),
    platformButtonClass() {
      return this.assets.every(asset => asset.platforms.length > 0) ? 'primary' : 'normal';
    }
  },
  validations: {
    form: {
      platforms: {
        required
      }
    }
  },
  methods: {
    ...mapActions('workflow', ['fetchProjectOptions']),
    ...mapActions('workflow/delivery', ['updateCurrentProjectFinalAsset']),
    handleEditClick() {
      this.form.platforms = [];
      this.$v.$reset();
      this.visible = true;
    },
    async updateFinalAssets() {
      this.loading = true;
      for (let asset of this.assets) {
        await this.updateCurrentProjectFinalAsset({
          asset: {
            ...asset,
            platforms: this.form.platforms
          }
        });
      }

      this.loading = false;
      this.form.platforms = [];
      this.$v.$reset();
    },
    handleSaveClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.updateFinalAssets();
        this.visible = false;
        if (this.callback) {
          window.EventBus.$emit('Delivery.ShareFinalAssets');
        }
        this.callback = null;
      }
    }
  }
};
</script>
